import './card-group-header.scss'

import { Link } from 'gatsby'
import _ from 'lodash'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Title from '@/components/title/title'

import { TrendingBottomCard } from './trending-bottom-card'
import { TrendingTopCard } from './trending-top-card'

const FilterHashLocation = () => (
  <div
    id="topic-filter-location"
    style={{
      display: 'block',
      position: 'relative',
      top: '-70px',
      visibility: 'hidden',
    }}
  />
)

const CardGroupHeader = ({
  title,
  titleUrl,
  data = [],
  onClick,
  type = 'event',
}) => {
  const firstCard = useMemo(() => _.head(data), [data])
  const restData = useMemo(() => data.slice(1, 4), [data])
  const { t } = useTranslation()
  return (
    <section className="container-card-group-header">
      <Link to={titleUrl || '/'}>
        <Title title={t(`card-group.trending-card.${title}`)} />
      </Link>
      {data.length > 0 && (
        <div className="cards-group-header">
          <div className="card-group-header-top">
            <TrendingTopCard
              item={_.get(firstCard, 'node')}
              onClick={onClick}
              type={type}
            />
          </div>
          <div className="box-card-group-header">
            {!_.isEmpty(restData) &&
              _.map(restData, (card) => (
                <TrendingBottomCard
                  key={card.node.id}
                  item={_.get(card, 'node')}
                  onClick={onClick}
                  type={type}
                />
              ))}
          </div>
        </div>
      )}
      <FilterHashLocation />
    </section>
  )
}

export default CardGroupHeader
